import "@/integrations/supabase/client"; // force-load client so env/debug logs print
import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "@/context/Auth";
import "./index.css";
import "./styles/print.css";

const root = createRoot(document.getElementById("root")!);

const AppWithProviders = () => (
  <BrowserRouter future={{ v7_relativeSplatPath: true }}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

const node = import.meta.env.PROD ? (
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
) : (
  <AppWithProviders />
);

root.render(node);